<div>
    <div>
        <p>Edytowane przez: {{ help.username }}</p>
        <p>Ostatnia modyfikacja: {{ help.updated | date: 'yyyy-MM-dd HH:mm:ss' }}</p>
    </div>
</div>
<div>
    <h3>Dla wszystkich userów:</h3>
    <quill-editor [(ngModel)]="help.content" class="vh-40"></quill-editor>
</div>
<div class="pt-3xl">
    <h3>Dla userów posiadających rolę rysowania ADHOC:</h3>
    <quill-editor [(ngModel)]="help.contentForDraw" class="vh-40"></quill-editor>
</div>
<div class="d-flex justify-content-end">
    <button pui-button (onClick)="save()">Zapisz</button>
</div>